
export class Alert {
    alertElement: HTMLElement;

    constructor(alertElement: HTMLElement, container?: HTMLElement) {
        setTimeout(() => {
            if (alertElement) {
                this.alertElement = alertElement;

                this.alertElement.querySelector('[data-close]')?.addEventListener('click', () => {
                    this.alertElement.style.display = 'none';
                    this.alertElement.classList.add('hide');
                })

            }
        }, 0)
    }
}